import React, { useEffect } from 'react';
import { Button, Table, Modal } from 'react-bootstrap';
import { formatterPeso, mFormat, PFLabelConstructor } from 'src/utils/utils';
import { getAdministrativeServiceByIdData } from '../../../../redux/administrativeService/administrativeServiceReducer';
import { trySearchAdministrativeServiceById } from '../../../../redux/administrativeService/administrativeServiceActionCreator';
import { useDispatch, useSelector } from 'react-redux';
import { NumericFormat } from 'react-number-format';

const ProvisionOrderDetailModal = (props) => {

    const dispatch = useDispatch();

    const { showProvisionOrderDetailModal, setShowProvisionOrderDetailModal, activeProvisionOrder, selectedFundRequestType } = props;
    const { acquisitionType, administrativeDocument, number, year, provisionOrderDate, initiator, destination, totalAmount, legalInstrument, provisionOrderRows } = activeProvisionOrder || {};

    const administrativeService = useSelector(state => getAdministrativeServiceByIdData(state));

    useEffect(() => {
        activeProvisionOrder?.administrativeServiceId && dispatch(trySearchAdministrativeServiceById(activeProvisionOrder?.administrativeServiceId))
    }, [activeProvisionOrder]);

    return (
        <Modal
            show={showProvisionOrderDetailModal}
            onHide={() => setShowProvisionOrderDetailModal(false)}
            dialogClassName="modal-xl"
        >
            <Modal.Header closeButton>
                <Modal.Title className='text-uppercase'>{`Detalle de la ${PFLabelConstructor(selectedFundRequestType)?.label}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped borderless hover className="shadow-sm p-2 mb-1 bg-white rounded text-black-color" >
                    <tbody>
                        <tr>
                            <td className='font-weight-bold text-left'>Tipo:</td>
                            <td className='text-left'>
                                {acquisitionType?.replace(/_/g, ' ')}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-left font-weight-bold'>
                                Servicio:
                            </td>
                            <td className='text-left' style={{ overflowWrap: 'anywhere' }}>
                                {`${administrativeService?.code} - ${administrativeService?.name}`}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>Expediente:</td>
                            <td className='text-left'>
                                {administrativeDocument?.codeOrganism}-{administrativeDocument?.number}/{administrativeDocument?.year}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>Instrumento legal:</td>
                            <td className='text-left'>
                                {legalInstrument?.legalInstrumentType?.name} - {legalInstrument?.number} - {legalInstrument?.year}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>{`${PFLabelConstructor(selectedFundRequestType)?.label}:`}</td>
                            <td className='text-left'>
                                {number}    -    {year}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>Fecha:</td>
                            <td className='text-left'>
                                {mFormat(provisionOrderDate)}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>Iniciador:</td>
                            <td className='text-left'>
                                {initiator}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>Destino:</td>
                            <td className='text-left'>
                                {destination}
                            </td>
                        </tr>
                        <tr>
                            <td className='font-weight-bold text-left'>Importe:</td>
                            <td className='text-left'>
                                {formatterPeso.format(totalAmount || 0)}
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <hr />
                <p className='font-weight-bold text-left'>Detalle de bienes y Servicios</p>
                <div style={{ overflowX: 'auto' }}>
                    <Table
                        striped
                        borderless
                        hover
                        className="shadow-sm p-2 mb-1 bg-white rounded text-black-color"
                        style={{ tableLayout: 'fixed', width: '100%', wordWrap: 'break-word' }}
                    >
                        <thead>
                            <tr>
                                <th className='text-center' style={{ "width": "10%" }}>Renglón</th>
                                <th className='text-center' style={{ "width": "20%" }}>Descripción</th>
                                <th className='text-center' style={{ "width": "20%" }}>Observación</th>
                                <th className='text-center' style={{ "width": "10%" }}>Cantidad</th>
                                <th className='text-center' style={{ "width": "10%" }}>U. Medida</th>
                                <th className='text-center' style={{ "width": "15%" }}>$ Unitario</th>
                                <th className='text-center' style={{ "width": "15%" }}>$ Total</th>
                            </tr>
                        </thead>
                        <tbody className='text-black-color'>
                            {provisionOrderRows?.map(item => (
                                <tr key={item?.id}>
                                    <td className='text-center'>
                                        {item?.provisionRowNumber}
                                    </td>
                                    <td className='text-center'>
                                        {item?.description}
                                    </td>
                                    <td className='text-center'>
                                        {item?.observations || '-'}
                                    </td>
                                    <td className='text-center'>
                                        <NumericFormat
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            allowLeadingZeros={false}
                                            decimalScale={6}
                                            value={item?.quantity}
                                            className={'form-control text-right'}
                                            readOnly
                                        />
                                    </td>
                                    <td className='text-center'>
                                        {item?.units}
                                    </td>
                                    <td className='text-center'>
                                        <NumericFormat
                                            prefix={'$'}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            allowLeadingZeros={false}
                                            decimalScale={6}
                                            value={item?.unitPrice}
                                            className={'form-control text-right'}
                                            readOnly
                                        />
                                    </td>
                                    <td className='text-center'>
                                        <NumericFormat
                                            prefix={'$'}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            allowLeadingZeros={false}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            value={item?.totalAmount}
                                            className={'form-control text-right'}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowProvisionOrderDetailModal(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ProvisionOrderDetailModal;